// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  WebhookDeliveryAttempt,
  WebhookDeliveryAttemptFromJSON,
  WebhookDeliveryAttemptToJSON,
  WebhookDeliveryState,
  WebhookDeliveryStateFromJSON,
  WebhookDeliveryStateToJSON,
  WebhookEventType,
  WebhookEventTypeFromJSON,
  WebhookEventTypeToJSON,
} from "./";

/**
 * One delivery of an event to an endpoint. event is the management API's event record ID; event_id is the stable UUID receivers use to deduplicate retries. The project is in the query.
 * @export
 * @interface WebhookDelivery
 */
export interface WebhookDelivery {
  /**
   *
   * @type {number}
   * @memberof WebhookDelivery
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof WebhookDelivery
   */
  webhook: number;
  /**
   *
   * @type {number}
   * @memberof WebhookDelivery
   */
  event: number;
  /**
   *
   * @type {string}
   * @memberof WebhookDelivery
   */
  eventId: string;
  /**
   *
   * @type {WebhookEventType}
   * @memberof WebhookDelivery
   */
  eventType: WebhookEventType;
  /**
   *
   * @type {WebhookDeliveryState}
   * @memberof WebhookDelivery
   */
  status: WebhookDeliveryState;
  /**
   *
   * @type {number}
   * @memberof WebhookDelivery
   */
  attemptCount: number;
  /**
   *
   * @type {number}
   * @memberof WebhookDelivery
   */
  maxAttempts: number;
  /**
   *
   * @type {string}
   * @memberof WebhookDelivery
   */
  nextAttemptAt: string;
  /**
   *
   * @type {string}
   * @memberof WebhookDelivery
   */
  createdAt: string;
  /**
   * Included by GET /webhookdeliveries/{id}, including an empty array before the first attempt. Omitted from delivery list rows.
   * @type {Array<WebhookDeliveryAttempt>}
   * @memberof WebhookDelivery
   */
  attempts?: Array<WebhookDeliveryAttempt>;
}

export function WebhookDeliveryFromJSON(json: any): WebhookDelivery {
  return {
    id: json["id"],
    webhook: json["webhook"],
    event: json["event"],
    eventId: json["event_id"],
    eventType: WebhookEventTypeFromJSON(json["event_type"]),
    status: WebhookDeliveryStateFromJSON(json["status"]),
    attemptCount: json["attempt_count"],
    maxAttempts: json["max_attempts"],
    nextAttemptAt: json["next_attempt_at"],
    createdAt: json["created_at"],
    attempts: !exists(json, "attempts")
      ? undefined
      : (json["attempts"] as Array<any>).map(WebhookDeliveryAttemptFromJSON),
  };
}

export function WebhookDeliveryToJSON(value?: WebhookDelivery): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    webhook: value.webhook,
    event: value.event,
    event_id: value.eventId,
    event_type: WebhookEventTypeToJSON(value.eventType),
    status: WebhookDeliveryStateToJSON(value.status),
    attempt_count: value.attemptCount,
    max_attempts: value.maxAttempts,
    next_attempt_at: value.nextAttemptAt,
    created_at: value.createdAt,
    attempts:
      value.attempts === undefined
        ? undefined
        : (value.attempts as Array<any>).map(WebhookDeliveryAttemptToJSON),
  };
}
